export const createGetTimeSlotsRequest = () => {
    return {
        url: "/time_slots",
        method: "GET"
    };
}

export const createSaveTimeSlotRequest = (day_of_week, hour, minute) => {
    return {
        url: "/time_slots",
        method: "POST",
        data: {
            day_of_week,
            hour,
            minute,
        },
    };
}

export const createDeleteTimeSlotRequest = (id) => {
    return {
        url: "/time_slots/" + id,
        method: "DELETE",
    };
}

export const createDeleteTimeSlotsRequest = (ids) => {
    return {
        url: "/time_slots",
        method: "DELETE",
        data: {
            ids,
        },
    };
}
